import "./technologies.css";

import TechHero from "./TechHero";
import TechPhilosophy from "./TechPhilosophy";
import TechFrontend from "./TechFrontend";
import TechBackend from "./TechBackend";
import TechMobile from "./TechMobile";
import TechDatabase from "./TechDatabase";
import TechCloudDevOps from "./TechCloudDevOps";
import TechDesignTools from "./TechDesignTools";
import TechSecurity from "./TechSecurity";
import TechIndustries from "./TechIndustries";
import TechWhyOglitz from "./TechWhyOglitz";
import TechCTA from "./TechCTA";
import TechQualityAndGrowth from "./TechQualityAndGrowth";
import GlobalCTA from './../components/GlobalCTA';

export default function Technologies() {
  return (
    <main className="technologies-page">
      <TechHero />
      <TechPhilosophy />
      <TechFrontend />
      <TechBackend />
      <TechMobile />
      <TechDatabase />
      <TechCloudDevOps />
      <TechDesignTools />
      <TechQualityAndGrowth />
      <TechSecurity />
      <TechIndustries />
      <TechWhyOglitz />
      <GlobalCTA
        title="Ready to Build"
        highlight="Scalable Technology?"
        subtitle="Let’s architect secure, high-performance web, mobile, and cloud systems engineered for long-term growth."
      />
    </main>
  );
}
